"use client";

import { c as _c } from "react/compiler-runtime";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { HtmlParser } from "@shared/ui";
import { ReplacementsMap } from "@shared/ui/html-parser";
import { domToReact, HTMLReactParserOptions } from "html-react-parser";
import Image from "next/image";
import Link from "next/link";
import { FooterNav } from "./footer-nav";
import { FooterSocialLink } from "./footer-social-link";
export function Footer() {
  const $ = _c(36);
  const clientConfig = useClientConfig();
  const footer = clientConfig?.layoutSettings?.attributes?.footer;
  const logo = footer?.logo?.data?.attributes;
  let t0;
  if ($[0] !== footer?.contacts) {
    t0 = footer?.contacts || [];
    $[0] = footer?.contacts;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const contacts = t0;
  let t1;
  if ($[2] !== footer?.socialLinks) {
    t1 = footer?.socialLinks || [];
    $[2] = footer?.socialLinks;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const socialLinks = t1;
  let t2;
  if ($[4] !== clientConfig?.layoutSettings?.attributes?.footerNavigation) {
    t2 = clientConfig?.layoutSettings?.attributes?.footerNavigation || [];
    $[4] = clientConfig?.layoutSettings?.attributes?.footerNavigation;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const footerNavigations = t2;
  const brandInfo = clientConfig?.layoutSettings?.attributes?.footer?.brandInfo || "";
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      a: _temp
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const replacementsMap = t3;
  const t4 = logo?.url || "";
  const t5 = logo?.alternativeText || logo?.name || "Footer image";
  const t6 = logo?.width;
  const t7 = logo?.height;
  let t8;
  if ($[7] !== t4 || $[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <Image src={t4} alt={t5} width={t6} height={t7} className="h-12 sm:h-14 w-auto" />;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== contacts) {
    t9 = contacts && contacts.length > 0 && <div className="flex flex-col gap-3 mt-8 sm:mt-9 md:mt-10 w-full">{contacts.map(contact => <div className="flex gap-2 items-start" key={contact.id}><Image src={contact.icon?.data?.attributes?.url || ""} alt={contact.icon?.data?.attributes?.alternativeText || contact.icon?.data?.attributes?.name} width={contact.icon?.data?.attributes?.width} height={contact.icon?.data?.attributes?.height} className="size-6 min-w-6 sm:size-5 sm:min-w-5 text-primary mt-1" /><div className="text-lg sm:text-md md:text-lg"><HtmlParser data={contact.title} redefine={replacementsMap} /></div></div>)}</div>;
    $[12] = contacts;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <div className="md:col-span-4">{t8}{t9}</div>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="hidden 2xl:block col-span-1" />;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== footerNavigations) {
    t12 = <div className="md:col-span-2 grid grid-cols-2 gap-9 xl:gap-[60px]"><FooterNav navs={footerNavigations} /></div>;
    $[18] = footerNavigations;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== footer || $[21] !== socialLinks) {
    t13 = footer && footer.title && <div className="md:col-span-1 xl:col-span-2"><div className="text-xl font-semibold text-primary-700 mb-4 flex items-center space-x-2">{footer.logos?.data?.attributes?.url && <Image src={footer.logos?.data?.attributes?.url || ""} alt={footer.logos?.data?.attributes?.alternativeText || footer.logos?.data?.attributes?.name || "Footer img"} width={footer.logos?.data?.attributes?.width} height={footer.logos?.data?.attributes?.height} className="size-6" />}<span>{footer.title}</span></div><div className="text-base sm:text-lg text-gray-700"><HtmlParser data={footer.description} /></div>{socialLinks && socialLinks.length > 0 && <div className="flex items-center gap-4 mt-8">{socialLinks.map(_temp2)}</div>}</div>;
    $[20] = footer;
    $[21] = socialLinks;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t12 || $[24] !== t13) {
    t14 = <div className="md:col-span-8 2xl:col-span-7 grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-10 sm:gap-9 xl:gap-[60px]">{t12}{t13}</div>;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t10 || $[27] !== t14) {
    t15 = <div className="footer-head"><div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">{t10}{t11}{t14}</div></div>;
    $[26] = t10;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== brandInfo) {
    t16 = brandInfo || `© ${new Date().getFullYear()} Saridana. All rights reserved`;
    $[29] = brandInfo;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t16) {
    t17 = <div className="flex items-center space-x-6 mt-[60px] sm:mt-20 pt-4 sm:pt-6 border-t border-gray-100"><div className="text-gray-700 flex-1 text-sm sm:text-base">{t16}</div></div>;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t15 || $[34] !== t17) {
    t18 = <footer className="text-grey-dark pt-20 sm:pt-[70px] pb-10"><div className="container">{t15}{t17}</div></footer>;
    $[33] = t15;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
}
function _temp2(socialLink) {
  return <FooterSocialLink key={socialLink.id} data={socialLink} />;
}
function _temp(domNode, options) {
  const href = domNode.attribs.href;
  return <Link href={href} className="hover:text-primary-600">{domToReact(domNode.children, options)}</Link>;
}